// import { useState, useEffect } from "react";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";
// import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
// import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
// import {
//   TableContainer,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Paper,
//   Card,
//   CardContent,
//   Box,
//   Button,
//   Checkbox,
//   useMediaQuery,
//   IconButton,
//   Menu,
//   MenuItem,
//   Divider,
//   Snackbar,
//   Alert,
// } from "@mui/material";
// import AppointmentEditModal from "../components/AppointmentEditModal";
// import { useTranslation } from "react-i18next";
// import AppointmentCommentModal from "../components/AppointmentCommentModal";
// import { AddComment, MoreVert } from "@mui/icons-material";
// import { useTheme } from "@mui/material/styles";

// const EditDeleteAppointment = ({ appointmentId, onSave, onDelete }) => {
//   const theme = useTheme();
//   const [appointments, setAppointments] = useState([]);
//   const [openModal, setOpenModal] = useState(false);
//   const [openCommentModal, setOpenCommentModal] = useState(false);
//   const [id, setId] = useState();
//   const { t } = useTranslation();
//   const { user } = useStateContext();
//   const isMobile = useMediaQuery("(max-width:600px)");

//   // Mobile actions menu state
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [selectedAppointment, setSelectedAppointment] = useState(null);

//   // State for Snackbar alerts
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");

//   const handleModalOpen = (id) => {
//     setId(id);
//     setOpenModal(true);
//     setAnchorEl(null);
//   };

//   const handleModalClose = () => {
//     setOpenModal(false);
//   };

//   const handleCommentModalOpen = (id) => {
//     setId(id);
//     setOpenCommentModal(true);
//     setAnchorEl(null);
//   };

//   const handleCommentModalClose = () => {
//     setOpenCommentModal(false);
//   };

//   const handleMenuOpen = (event, appointment) => {
//     setAnchorEl(event.currentTarget);
//     setSelectedAppointment(appointment);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//     setSelectedAppointment(null);
//   };

//   // Close Snackbar
//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setSnackbarOpen(false);
//   };

//   const getAppointment = () => {
//     axiosClient
//       .get("api/print_appointments/")
//       .then((res) => {
//         setAppointments(res?.data);
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };

//   useEffect(() => {
//     getAppointment();
//   }, []);

//   const handleDelete = (appointmentId) => {
//     axiosClient
//       .delete(`api/appointment/${appointmentId}/`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//         },
//       })
//       .then((response) => {
//         getAppointment();
//         handleMenuClose();
//       })
//       .catch((error) => {
//         console.error("Error deleting appointment:", error);
//       });
//   };

//   const handleSendEmail = (id) => {
//     axiosClient
//       .post("api/send_email/", {
//         appointment_id: id,
//       })
//       .then((res) => {
//         setSnackbarMessage(t("Email sent successfully"));
//         setSnackbarSeverity("success");
//         setSnackbarOpen(true);
//         handleMenuClose();
//       })
//       .catch((error) => {
//         setSnackbarMessage(t("Failed to send email"));
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//         console.log(error);
//       });
//   };

//   const handleSendSMS = (id) => {
//     axiosClient
//       .post(`api/send_appointment_info/${id}/`)
//       .then((res) => {
//         setSnackbarMessage(t("SMS sent successfully"));
//         setSnackbarSeverity("success");
//         setSnackbarOpen(true);
//         handleMenuClose();
//       })
//       .catch((error) => {
//         setSnackbarMessage(t("Failed to send SMS"));
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//         console.log(error);
//       });
//   };

//   const handleCheckboxChange = (appointmentId, isSelected, name) => {
//     setAppointments((prevAppointments) =>
//       prevAppointments.map((appointment) =>
//         appointment.id === appointmentId
//           ? { ...appointment, [name]: !isSelected }
//           : appointment
//       )
//     );

//     if (selectedAppointment && selectedAppointment.id === appointmentId) {
//       setSelectedAppointment({
//         ...selectedAppointment,
//         [name]: !isSelected,
//       });
//     }

//     axiosClient
//       .patch(`api/appointment-edit/${appointmentId}/`, {
//         [name]: !isSelected,
//       })
//       .then((res) => {
//         console.log(`${name} status updated successfully`);
//       })
//       .catch((error) => {
//         console.error(error);
//         setAppointments((prevAppointments) =>
//           prevAppointments.map((appointment) =>
//             appointment.id === appointmentId
//               ? { ...appointment, [name]: isSelected }
//               : appointment
//           )
//         );
//         if (selectedAppointment && selectedAppointment.id === appointmentId) {
//           setSelectedAppointment({
//             ...selectedAppointment,
//             [name]: isSelected,
//           });
//         }
//       });
//   };

//   return (
//     <>
//       <Box
//         display="flex"
//         justifyContent="center"
//         alignItems="center"
//         sx={{
//           margin: { xs: 1, sm: 4 },
//           padding: { xs: 0, sm: 2 },
//         }}
//       >
//         {/* Snackbar for Alerts */}
//         <Snackbar
//           open={snackbarOpen}
//           autoHideDuration={5000}
//           onClose={handleSnackbarClose}
//           anchorOrigin={{ vertical: "top", horizontal: "right" }}
//           sx={{ top: { xs: 70, sm: 80 } }} // Adjusted to be slightly lower from the top
//         >
//           <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: "100%" }}>
//             {snackbarMessage}
//           </Alert>
//         </Snackbar>
//         <Card elevation={3} sx={{ width: "100%" }}>
//           <CardContent sx={{ padding: { xs: 1, sm: 2 } }}>
//             <TableContainer
//               component={Paper}
//               sx={{
//                 maxHeight: { xs: "70vh", sm: "80vh" },
//                 overflowX: "auto",
//               }}
//             >
//               <Table stickyHeader size={isMobile ? "small" : "medium"}>
//                 <TableHead>
//                   <TableRow>
//                     {isMobile ? (
//                       <>
//                         <TableCell sx={{ fontWeight: "bold", fontSize: "0.85rem", whiteSpace: "nowrap", padding: "8px" }}>
//                           {t("Doctor & Patient")}
//                         </TableCell>
//                         <TableCell sx={{ fontWeight: "bold", fontSize: "0.85rem", whiteSpace: "nowrap", padding: "8px" }}>
//                           {t("Appointment Details")}
//                         </TableCell>
//                         <TableCell sx={{ fontWeight: "bold", fontSize: "0.85rem", textAlign: "center", padding: "8px" }}>
//                           {t("Actions")}
//                         </TableCell>
//                       </>
//                     ) : (
//                       [
//                         t("Staff"),
//                         t("Client"),
//                         t("Appointment Date"),
//                         t("Appointment Start"),
//                         t("Appointment End"),
//                         t("Action"),
//                         t("Patient Arrival"),
//                         t("Patient Informed"),
//                         t("Send Email/SMS"),
//                         t("Comment"),
//                       ].map((header, index) => (
//                         <TableCell
//                           key={index}
//                           sx={{
//                             fontWeight: "bold",
//                             fontSize: "0.9rem",
//                             textAlign: index >= 5 && index <= 8 ? "center" : "left",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {header}
//                         </TableCell>
//                       ))
//                     )}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {appointments.map((appointment) => (
//                     <TableRow key={appointment?.id}>
//                       {isMobile ? (
//                         <>
//                           <TableCell sx={{ fontSize: "0.8rem", whiteSpace: "nowrap", padding: "6px" }}>
//                             <div style={{ fontWeight: "500" }}>Doctor:</div>
//                             {appointment.staff_name} {appointment.staff_surname}
//                             <div style={{ fontWeight: "500", marginTop: "4px" }}>Patient:</div>
//                             {appointment.client_name} {appointment.client_surname}
//                           </TableCell>
//                           <TableCell sx={{ fontSize: "0.8rem", whiteSpace: "nowrap", padding: "6px" }}>
//                             <div style={{ fontWeight: "500" }}>Date:</div>
//                             {appointment?.appointment_date}
//                             <div style={{ fontWeight: "500", marginTop: "4px" }}>Start:</div>
//                             {appointment?.appointment_start}
//                             <div style={{ fontWeight: "500", marginTop: "4px" }}>End:</div>
//                             {appointment?.appointment_end}
//                           </TableCell>
//                           <TableCell sx={{ textAlign: "center", padding: "6px" }}>
//                             <IconButton size="small" onClick={(e) => handleMenuOpen(e, appointment)}>
//                               <MoreVert />
//                             </IconButton>
//                           </TableCell>
//                         </>
//                       ) : (
//                         <>
//                           <TableCell sx={{ fontSize: "0.875rem", whiteSpace: "nowrap" }}>
//                             {appointment.staff_name} {appointment.staff_surname}
//                           </TableCell>
//                           <TableCell sx={{ fontSize: "0.875rem", whiteSpace: "nowrap" }}>
//                             {appointment.client_name} {appointment.client_surname}
//                           </TableCell>
//                           <TableCell sx={{ fontSize: "0.875rem", whiteSpace: "nowrap" }}>
//                             {appointment?.appointment_date}
//                           </TableCell>
//                           <TableCell sx={{ fontSize: "0.875rem", whiteSpace: "nowrap" }}>
//                             {appointment?.appointment_start}
//                           </TableCell>
//                           <TableCell sx={{ fontSize: "0.875rem", whiteSpace: "nowrap" }}>
//                             {appointment?.appointment_end}
//                           </TableCell>
//                           <TableCell sx={{ textAlign: "center" }}>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "center" }}>
//                               <BorderColorOutlinedIcon
//                                 sx={{ cursor: "pointer", color: `${theme.palette.mode === "dark" ? "orange" : "blue"}` }}
//                                 onClick={() => handleModalOpen(appointment?.id)}
//                               />
//                               <DeleteOutlineOutlinedIcon
//                                 onClick={() => handleDelete(appointment?.id)}
//                                 sx={{ cursor: "pointer", color: "red" }}
//                               />
//                             </Box>
//                           </TableCell>
//                           <TableCell sx={{ textAlign: "center" }}>
//                             <Checkbox
//                               checked={appointment.patient_arival || false}
//                               onChange={() =>
//                                 handleCheckboxChange(appointment.id, appointment.patient_arival, "patient_arival")
//                               }
//                               size="medium"
//                             />
//                           </TableCell>
//                           <TableCell sx={{ textAlign: "center" }}>
//                             <Checkbox
//                               checked={appointment.patient_informed}
//                               onChange={() =>
//                                 handleCheckboxChange(appointment.id, appointment.patient_informed, "patient_informed")
//                               }
//                               size="medium"
//                             />
//                           </TableCell>
//                           <TableCell sx={{ textAlign: "center" }}>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "center" }}>
//                               <Button
//                                 variant="contained"
//                                 size="small"
//                                 onClick={() => handleSendEmail(appointment?.id)}
//                                 sx={{ fontSize: "0.8rem" }}
//                               >
//                                 {/* Email */}
//                                   {t("Email")}
//                               </Button>
//                               <Button
//                                 variant="contained"
//                                 size="small"
//                                 onClick={() => handleSendSMS(appointment?.id)}
//                                 sx={{ fontSize: "0.8rem" }}
//                               >
//                                 {/* SMS */}
//                                  {t("SMS")}
//                               </Button>
//                             </Box>
//                           </TableCell>
//                           <TableCell sx={{ textAlign: "center" }}>
//                             {(user.user_role === "ADMIN" || appointment.client_staff_id === user.id) && (
//                               <AddComment
//                                 sx={{ cursor: "pointer", color: `${theme.palette.mode === "dark" ? "orange" : "blue"}` }}
//                                 onClick={() => handleCommentModalOpen(appointment.id)}
//                               />
//                             )}
//                           </TableCell>
//                         </>
//                       )}
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </CardContent>
//         </Card>
//       </Box>

//       {/* Mobile Actions Menu */}
//       <Menu
//         anchorEl={anchorEl}
//         open={Boolean(anchorEl)}
//         onClose={handleMenuClose}
//         PaperProps={{
//           sx: { width: "200px", maxWidth: "100%" },
//         }}
//       >
//         <MenuItem onClick={() => selectedAppointment && handleModalOpen(selectedAppointment.id)}>
//           <BorderColorOutlinedIcon fontSize="small" sx={{ mr: 1, color: `${theme.palette.mode === "dark" ? "orange" : "blue"}` }} />
//           Edit Appointment
//         </MenuItem>
//         <MenuItem onClick={() => selectedAppointment && handleDelete(selectedAppointment.id)}>
//           <DeleteOutlineOutlinedIcon fontSize="small" sx={{ mr: 1, color: "red" }} />
//           Delete Appointment
//         </MenuItem>
//         <Divider />
//         <MenuItem
//           onClick={() =>
//             selectedAppointment &&
//             handleCheckboxChange(selectedAppointment.id, selectedAppointment.patient_arival, "patient_arival")
//           }
//         >
//           <Checkbox checked={selectedAppointment?.patient_arival || false} size="small" sx={{ p: 0, mr: 1 }} />
//           Patient Arrival
//         </MenuItem>
//         <MenuItem
//           onClick={() =>
//             selectedAppointment &&
//             handleCheckboxChange(selectedAppointment.id, selectedAppointment.patient_informed, "patient_informed")
//           }
//         >
//           <Checkbox checked={selectedAppointment?.patient_informed || false} size="small" sx={{ p: 0, mr: 1 }} />
//           Patient Informed
//         </MenuItem>
//         <Divider />
//         <MenuItem onClick={() => selectedAppointment && handleSendEmail(selectedAppointment.id)}>Send Email</MenuItem>
//         <MenuItem onClick={() => selectedAppointment && handleSendSMS(selectedAppointment.id)}>Send SMS</MenuItem>
//         {selectedAppointment && (user.user_role === "ADMIN" || selectedAppointment.client_staff_id === user.id) && (
//           <>
//             <Divider />
//             <MenuItem onClick={() => selectedAppointment && handleCommentModalOpen(selectedAppointment.id)}>
//               <AddComment fontSize="small" sx={{ mr: 1, color: `${theme.palette.mode === "dark" ? "orange" : "blue"}` }} />
//               Add Comment
//             </MenuItem>
//           </>
//         )}
//       </Menu>

//       <AppointmentEditModal open={openModal} handleClose={handleModalClose} id={id} getAppointment={getAppointment} />
//       <AppointmentCommentModal
//         open={openCommentModal}
//         handleClose={handleCommentModalClose}
//         id={id}
//         getAppointment={getAppointment}
//       />
//     </>
//   );
// };

// export default EditDeleteAppointment;

import { useState, useEffect } from "react";
import axiosClient from "../axiosClient";
import { useStateContext } from "../context/ContextProvider";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Card,
  CardContent,
  Box,
  Button,
  Checkbox,
  useMediaQuery,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import AppointmentEditModal from "../components/AppointmentEditModal";
import { useTranslation } from "react-i18next";
import AppointmentCommentModal from "../components/AppointmentCommentModal";
import { AddComment, MoreVert } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

const EditDeleteAppointment = ({ appointmentId, onSave, onDelete }) => {
  const theme = useTheme();
  const [appointments, setAppointments] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openCommentModal, setOpenCommentModal] = useState(false);
  const [id, setId] = useState();
  const { t } = useTranslation();
  const { user } = useStateContext();
  const isMobile = useMediaQuery("(max-width:600px)");

  // Mobile actions menu state
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedAppointment, setSelectedAppointment] = useState(null);

  // State for Snackbar alerts
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  // State for SMS language dialog
  const [smsDialogOpen, setSmsDialogOpen] = useState(false);
  const [smsLanguage, setSmsLanguage] = useState("en");
  const [smsAppointmentId, setSmsAppointmentId] = useState(null);

  const handleModalOpen = (id) => {
    setId(id);
    setOpenModal(true);
    setAnchorEl(null);
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleCommentModalOpen = (id) => {
    setId(id);
    setOpenCommentModal(true);
    setAnchorEl(null);
  };

  const handleCommentModalClose = () => {
    setOpenCommentModal(false);
  };

  const handleMenuOpen = (event, appointment) => {
    setAnchorEl(event.currentTarget);
    setSelectedAppointment(appointment);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedAppointment(null);
  };

  // Close Snackbar
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const getAppointment = () => {
    axiosClient
      .get("api/print_appointments/")
      .then((res) => {
        setAppointments(res?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getAppointment();
  }, []);

  const handleDelete = (appointmentId) => {
    axiosClient
      .delete(`api/appointment/${appointmentId}/`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      })
      .then((response) => {
        getAppointment();
        handleMenuClose();
      })
      .catch((error) => {
        console.error("Error deleting appointment:", error);
      });
  };

  const handleSendEmail = (id) => {
    axiosClient
      .post("api/send_email/", {
        appointment_id: id,
      })
      .then((res) => {
        setSnackbarMessage(t("Email sent successfully"));
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        handleMenuClose();
      })
      .catch((error) => {
        setSnackbarMessage(t("Failed to send email"));
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        console.log(error);
      });
  };

  // Open SMS language dialog
  const openSmsDialog = (id) => {
    setSmsAppointmentId(id);
    setSmsDialogOpen(true);
    handleMenuClose();
  };

  // Close SMS language dialog
  const closeSmsDialog = () => {
    setSmsDialogOpen(false);
    setSmsAppointmentId(null);
  };

  // Send SMS with selected language
  const handleSendSMS = () => {
    if (!smsAppointmentId) return;

    axiosClient
      .post(`api/send_appointment_info/${smsAppointmentId}/`, {
        language: smsLanguage,
      })
      .then((res) => {
        setSnackbarMessage(t("SMS sent successfully"));
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        closeSmsDialog();
      })
      .catch((error) => {
        setSnackbarMessage(t("Failed to send SMS"));
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        console.log(error);
        closeSmsDialog();
      });
  };

  const handleCheckboxChange = (appointmentId, isSelected, name) => {
    setAppointments((prevAppointments) =>
      prevAppointments.map((appointment) =>
        appointment.id === appointmentId
          ? { ...appointment, [name]: !isSelected }
          : appointment
      )
    );

    if (selectedAppointment && selectedAppointment.id === appointmentId) {
      setSelectedAppointment({
        ...selectedAppointment,
        [name]: !isSelected,
      });
    }

    axiosClient
      .patch(`api/appointment-edit/${appointmentId}/`, {
        [name]: !isSelected,
      })
      .then((res) => {
        console.log(`${name} status updated successfully`);
      })
      .catch((error) => {
        console.error(error);
        setAppointments((prevAppointments) =>
          prevAppointments.map((appointment) =>
            appointment.id === appointmentId
              ? { ...appointment, [name]: isSelected }
              : appointment
          )
        );
        if (selectedAppointment && selectedAppointment.id === appointmentId) {
          setSelectedAppointment({
            ...selectedAppointment,
            [name]: isSelected,
          });
        }
      });
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          margin: { xs: 1, sm: 4 },
          padding: { xs: 0, sm: 2 },
        }}
      >
        {/* Snackbar for Alerts */}
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={5000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: { xs: 70, sm: 80 } }} // Adjusted to be slightly lower from the top
        >
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: "100%" }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
        <Card elevation={3} sx={{ width: "100%" }}>
          <CardContent sx={{ padding: { xs: 1, sm: 2 } }}>
            <TableContainer
              component={Paper}
              sx={{
                maxHeight: { xs: "70vh", sm: "80vh" },
                overflowX: "auto",
              }}
            >
              <Table stickyHeader size={isMobile ? "small" : "medium"}>
                <TableHead>
                  <TableRow>
                    {isMobile ? (
                      <>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            fontSize: "0.85rem",
                            whiteSpace: "nowrap",
                            padding: "8px",
                          }}
                        >
                          {t("Doctor & Patient")}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            fontSize: "0.85rem",
                            whiteSpace: "nowrap",
                            padding: "8px",
                          }}
                        >
                          {t("Appointment Details")}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            fontSize: "0.85rem",
                            textAlign: "center",
                            padding: "8px",
                          }}
                        >
                          {t("Actions")}
                        </TableCell>
                      </>
                    ) : (
                      [
                        t("Staff"),
                        t("Client"),
                        t("Appointment Date"),
                        t("Appointment Start"),
                        t("Appointment End"),
                        t("Action"),
                        t("Patient Arrival"),
                        t("Patient Informed"),
                        t("Send Email/SMS"),
                        t("Comment"),
                      ].map((header, index) => (
                        <TableCell
                          key={index}
                          sx={{
                            fontWeight: "bold",
                            fontSize: "0.9rem",
                            textAlign: index >= 5 && index <= 8 ? "center" : "left",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {header}
                        </TableCell>
                      ))
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {appointments.map((appointment) => (
                    <TableRow key={appointment?.id}>
                      {isMobile ? (
                        <>
                          <TableCell
                            sx={{
                              fontSize: "0.8rem",
                              whiteSpace: "nowrap",
                              padding: "6px",
                            }}
                          >
                            <div style={{ fontWeight: "500" }}>{t("Doctor")}:</div>
                            {appointment.staff_name} {appointment.staff_surname}
                            <div style={{ fontWeight: "500", marginTop: "4px" }}>
                              {t("Patient")}:
                            </div>
                            {appointment.client_name} {appointment.client_surname}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: "0.8rem",
                              whiteSpace: "nowrap",
                              padding: "6px",
                            }}
                          >
                            <div style={{ fontWeight: "500" }}>{t("Date")}:</div>
                            {appointment?.appointment_date}
                            <div style={{ fontWeight: "500", marginTop: "4px" }}>
                              {t("Start")}:
                            </div>
                            {appointment?.appointment_start}
                            <div style={{ fontWeight: "500", marginTop: "4px" }}>
                              {t("End")}:
                            </div>
                            {appointment?.appointment_end}
                          </TableCell>
                          <TableCell sx={{ textAlign: "center", padding: "6px" }}>
                            <IconButton
                              size="small"
                              onClick={(e) => handleMenuOpen(e, appointment)}
                            >
                              <MoreVert />
                            </IconButton>
                          </TableCell>
                        </>
                      ) : (
                        <>
                          <TableCell
                            sx={{ fontSize: "0.875rem", whiteSpace: "nowrap" }}
                          >
                            {appointment.staff_name} {appointment.staff_surname}
                          </TableCell>
                          <TableCell
                            sx={{ fontSize: "0.875rem", whiteSpace: "nowrap" }}
                          >
                            {appointment.client_name} {appointment.client_surname}
                          </TableCell>
                          <TableCell
                            sx={{ fontSize: "0.875rem", whiteSpace: "nowrap" }}
                          >
                            {appointment?.appointment_date}
                          </TableCell>
                          <TableCell
                            sx={{ fontSize: "0.875rem", whiteSpace: "nowrap" }}
                          >
                            {appointment?.appointment_start}
                          </TableCell>
                          <TableCell
                            sx={{ fontSize: "0.875rem", whiteSpace: "nowrap" }}
                          >
                            {appointment?.appointment_end}
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                justifyContent: "center",
                              }}
                            >
                              <BorderColorOutlinedIcon
                                sx={{
                                  cursor: "pointer",
                                  color:
                                    theme.palette.mode === "dark"
                                      ? "orange"
                                      : "blue",
                                }}
                                onClick={() =>
                                  handleModalOpen(appointment?.id)
                                }
                              />
                              <DeleteOutlineOutlinedIcon
                                onClick={() =>
                                  handleDelete(appointment?.id)
                                }
                                sx={{ cursor: "pointer", color: "red" }}
                              />
                            </Box>
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            <Checkbox
                              checked={appointment.patient_arival || false}
                              onChange={() =>
                                handleCheckboxChange(
                                  appointment.id,
                                  appointment.patient_arival,
                                  "patient_arival"
                                )
                              }
                              size="medium"
                            />
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            <Checkbox
                              checked={appointment.patient_informed}
                              onChange={() =>
                                handleCheckboxChange(
                                  appointment.id,
                                  appointment.patient_informed,
                                  "patient_informed"
                                )
                              }
                              size="medium"
                            />
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                justifyContent: "center",
                              }}
                            >
                              <Button
                                variant="contained"
                                size="small"
                                onClick={() =>
                                  handleSendEmail(appointment?.id)
                                }
                                sx={{ fontSize: "0.8rem" }}
                              >
                                {t("Email")}
                              </Button>
                              <Button
                                variant="contained"
                                size="small"
                                onClick={() =>
                                  openSmsDialog(appointment?.id)
                                }
                                sx={{ fontSize: "0.8rem" }}
                              >
                                {t("SMS")}
                              </Button>
                            </Box>
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            {(user.user_role === "ADMIN" ||
                              appointment.client_staff_id === user.id) && (
                                <AddComment
                                  sx={{
                                    cursor: "pointer",
                                    color:
                                      theme.palette.mode === "dark"
                                        ? "orange"
                                        : "blue",
                                  }}
                                  onClick={() =>
                                    handleCommentModalOpen(appointment.id)
                                  }
                                />
                              )}
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Box>

      {/* Mobile Actions Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: { width: "200px", maxWidth: "100%" },
        }}
      >
        <MenuItem
          onClick={() =>
            selectedAppointment && handleModalOpen(selectedAppointment.id)
          }
        >
          <BorderColorOutlinedIcon
            fontSize="small"
            sx={{
              mr: 1,
              color: `${theme.palette.mode === "dark" ? "orange" : "blue"}`,
            }}
          />
          {t("Edit Appointment")}
        </MenuItem>
        <MenuItem
          onClick={() =>
            selectedAppointment && handleDelete(selectedAppointment.id)
          }
        >
          <DeleteOutlineOutlinedIcon
            fontSize="small"
            sx={{ mr: 1, color: "red" }}
          />
          {t("Delete Appointment")}
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() =>
            selectedAppointment &&
            handleCheckboxChange(
              selectedAppointment.id,
              selectedAppointment.patient_arival,
              "patient_arival"
            )
          }
        >
          <Checkbox
            checked={selectedAppointment?.patient_arival || false}
            size="small"
            sx={{ p: 0, mr: 1 }}
          />
          {t("Patient Arrival")}
        </MenuItem>
        <MenuItem
          onClick={() =>
            selectedAppointment &&
            handleCheckboxChange(
              selectedAppointment.id,
              selectedAppointment.patient_informed,
              "patient_informed"
            )
          }
        >
          <Checkbox
            checked={selectedAppointment?.patient_informed || false}
            size="small"
            sx={{ p: 0, mr: 1 }}
          />
          {t("Patient Informed")}
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() =>
            selectedAppointment && handleSendEmail(selectedAppointment.id)
          }
        >
          {t("Send Email")}
        </MenuItem>
        <MenuItem
          onClick={() =>
            selectedAppointment && openSmsDialog(selectedAppointment.id)
          }
        >
          {t("Send SMS")}
        </MenuItem>
        {selectedAppointment &&
          (user.user_role === "ADMIN" ||
            selectedAppointment.client_staff_id === user.id) && (
            <>
              <Divider />
              <MenuItem
                onClick={() =>
                  selectedAppointment &&
                  handleCommentModalOpen(selectedAppointment.id)
                }
              >
                <AddComment
                  fontSize="small"
                  sx={{
                    mr: 1,
                    color: `${theme.palette.mode === "dark" ? "orange" : "blue"}`,
                  }}
                />
                {t("Add Comment")}
              </MenuItem>
            </>
          )}
      </Menu>

      <AppointmentEditModal
        open={openModal}
        handleClose={handleModalClose}
        id={id}
        getAppointment={getAppointment}
      />
      <AppointmentCommentModal
        open={openCommentModal}
        handleClose={handleCommentModalClose}
        id={id}
        getAppointment={getAppointment}
      />

      {/* SMS Language Selection Dialog */}
      <Dialog open={smsDialogOpen} onClose={closeSmsDialog}>
        <DialogTitle>{t("Select SMS Language")}</DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>{t("Language")}</InputLabel>
            <Select
              value={smsLanguage}
              label={t("Language")}
              onChange={(e) => setSmsLanguage(e.target.value)}
            >
              <MenuItem value="en">{t("English")}</MenuItem>
              <MenuItem value="el">{t("Greek")}</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeSmsDialog}>{t("Cancel")}</Button>
          <Button onClick={handleSendSMS} variant="contained">
            {t("Send SMS")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditDeleteAppointment;
